import { BsStar, BsStarFill, BsStarHalf } from "react-icons/bs";
import { Rating as RatingInterface } from "../../others/accomodation.interfaces"
import { uniqueId, arr } from "../../others/oneliners";
import { SpanSkeleton } from "../skeletonTemplates/skeletons";

interface RatingProps extends RatingInterface {
    institutionType: string;
    skeleton?: boolean;
}

const Rating = ({ rating, raters, institutionType, skeleton }: RatingProps): JSX.Element => {
    if (skeleton) return <RatingSkeleton />
    return (
        <div className="flex flex-col gap-1">
            <h3>Rating</h3>
            <div className="flex gap-2 items-center">
                <Stars num={rating} />
                <span className="text-sm">{rating}</span>
            </div>
            <span className="text-gray-400 text-sm">{raters} users reviewed this {institutionType}</span>
        </div>
    )
}

export default Rating

interface StarsProps {
    num: number;
}

export const Stars = ({ num }: StarsProps): JSX.Element => {
    num = (num > 5 || num < 0) ? 0 : num;
    if (!num) return <div className="flex items-center gap-1"> {Array(5).map(() => <BsStar fill="#FABD3B" key={uniqueId()} />)}</div>;

    const fullStars = Math.floor(num);
    const halfStar = fullStars !== Math.ceil(num);
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);
    return (
        <div className="flex items-center gap-1">
            {
                arr(fullStars, '').map(() => <BsStarFill fill="#FABD3B" key={uniqueId()} />)
            }
            {
                halfStar && <BsStarHalf fill="#FABD3B" />
            }
            {
                arr(emptyStars, '').map(() => <BsStar fill="#FABD3B" key={uniqueId()} />)
            }
        </div>
    )
}

export const RatingSkeleton = (): JSX.Element => {
    return (
        <div className="flex flex-col gap-1">
            <h3>Rating</h3>
            <div className="flex gap-2 items-center">
                <Stars num={0} />
                <SpanSkeleton />
            </div>
            <SpanSkeleton />
        </div>
    )
}